/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IrrCertMinResponse { 
    /**
     * Valid till date of the certificate.
     */
    expiry_ts?: Date;
    /**
     * Last rotated timestamp of the certificate.
     */
    last_rotated_ts?: Date;
    /**
     * Last rotated by user.
     */
    last_rotated_by?: string;
    /**
     * Denotes whether the live certificate matches with the admin account and that the one pushed in to shadow account.
     */
    in_sync?: boolean;
    /**
     * Last probe timestamp of the certificate.
     */
    last_probe_ts?: Date;
    /**
     * Updated timestamp of the certificate.
     */
    updated_ts?: Date;
    /**
     * Updated by user.
     */
    updated_by?: string;
}

